export default "__VITE_PUBLIC_ASSET__ac95530d__"